import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';
import './Footer.css';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo-section">
          <Link to="/" className="footer-logo">
            <img src={logo} alt="Scholify Logo" className="footer-logo-img" />
          </Link>
          <p className="footer-description">
            Scholify is South Africa's best mathematics e-learning platform
            offering comprehensive interactive lessons, unlimited practice
            exercises, and assessments for Grade 4-12 students.
          </p>
          <h3 className="footer-heading">Connect With Us</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/people/Scholify/61574725322261/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
          </div>
        </div>

        <div className="footer-links-container">
          <div className="footer-links-column">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/features">Features</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-beta-note">Scholify is currently in beta. We&apos;re improving it with your feedback.</p>
        <div className="footer-bottom-row">
          <p className="copyright">
            &copy; {year} Scholify. All rights reserved.
          </p>
          <p className="address">
            Gqeberha, South Africa
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
